/* eslint-disable react/jsx-pascal-case */
import uni from "../../../images/fb0bb5cd017b15aa49ee7a86a2e0c972.png";

import Add from "../../Buttons/Add";
import News_Card from "../../News_Card/News_Card";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import { fileURL, useDelete, useFetch, useFilter } from "../../../ApiS";
import PopUpDelete from "../../PopUps/PopUpDelete (1)";
import Loader from "../../Loader";
import { usePopUpsStore } from "../../../store/PopUpStore";
import Table, { TableOperation } from "../../Table";
import { RiEditBoxFill } from "react-icons/ri";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import Pagination from "../../pagination/Pagination (1)";

interface New {
  id: string | number;
  ar_title: string;

  en_title: string;

  ar_description: string;

  en_description: string;

  images: Image[];
}
interface Image {
  id: string | number;
  url: string;
}

interface NewsData {
  data: { data: New[]; last_page: number };
}

export default function News() {
  const operations: TableOperation[] = [
    {
      name: "show",
      icon: FaEye,
      link: true,
      onClick: () => {
        console.log("View");
      },
    },
    {
      name: "edit",
      icon: RiEditBoxFill,
      link: true,
      onClick: () => {
        console.log("edit");
      },
    },
    {
      name: "delete",
      icon: FaRegTrashAlt,
      link: true,
      onClick: (id) => {
        setPopUpDelete([id, true]);
      },
    },
  ];
  const { searchParams, handleParamsClick, handleParamDelete } = useFilter();
  const { setPopUpDelete, popUpDelete } = usePopUpsStore();

  const page = searchParams.get("page") || 1;
  const search = searchParams.get("search") || "";

  const { data, isLoading } = useFetch(
    `admin/news?page=${page}&search=${search}`,
    "news"
  );
  // console.log(data);

  const { mutation, deleteItem } = useDelete(
    () => window.location.reload(),
    () => console.log(mutation.error)
  );

  return (
    <>
      <Row>
        <Col>
          <Title title="الأخبار" />
        </Col>
      </Row>
      {/* {data?.data?.data?.map((e : any, id : any) => (
        <div key={e.id}>
          <img src={fileURL + e.images[0]?.url} alt="" className="w-96 h-96" />
        </div>
      ))} */}
      {isLoading && <Loader />}
      <Row>
        <Table<New>
          tableHeads={[
            "رقم الاعلان",
            "العنوان بالعربي",
            "الوصف بالعربي",
            "العمليات",
          ]}
          tableBody={data?.data?.data}
          keys={["id", "ar_title", "ar_description"]}
          operations={operations}
          className="lg:min-w-[100px] md:min-w-[50px]"
        />
        {data?.data?.data?.length > 0 && (
          <Pagination pageCount={data?.data?.last_page} />
        )}

        <PopUpDelete
          text="هل أنت متأكد من حذف هذا الاعلان؟"
          onClickDelete={() => {
            deleteItem(`admin/news/${popUpDelete[0]}`);
            mutation.isLoading && <Loader />;
          }}
        />
      </Row>

      <Add link="/news/createnews" />
    </>
  );
}
